<template>
  <div id="contenedor-obras-default">
    <v-container fluid>
      <v-card
        class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Planeación">
            <template v-slot:opciones-derecha>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="mostrarExportarObras= !mostrarExportarObras">
                    <v-icon> mdi-file-excel </v-icon>
                  </v-btn>
                </template>
                <span> Exportar Obras </span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :listaObras="getObras"
            :filtros="filtros"
            v-on:nuevaObra="registrarNuevaObra"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-else
            :listadoObras="getListadoObras">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaObra"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <registrar-nueva-obra
        v-if="mostrarVentanaRegistrarNuevaObra"
        v-on:cerrar="cerrarRegistrarNuevaObra">
      </registrar-nueva-obra>
    </v-dialog>
    <v-dialog
      v-if="estaObra"
      v-model="mostrarVentanaEditarObra"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-obra
        :obraEditar="estaObra"
        v-on:cerrar="cerrarEditarObra">
      </editar-obra>
    </v-dialog>
    <v-dialog
      v-if="estaObra"
      v-model="mostrarVentanaEliminarObra"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-obra
        :obraEliminar="estaObra"
        v-on:cerrar="cerrarRemoverObra">
      </eliminar-obra>
    </v-dialog>
    <v-dialog
      v-if="mostrarExportarObras"
      v-model="mostrarExportarObras"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <exportar-obras-excel
        :obras="getObras"
        :filtros="this.filtros"
        v-on:cerrar="mostrarExportarObras = !mostrarExportarObras">
      </exportar-obras-excel>
    </v-dialog>
    <v-dialog
      v-if="estaObra"
      v-model="mostrarRegistrarProyecto"
      :width="$vuetify.breakpoint.mobile ? '100%' : '40%'"
      scrollable
      permanent>
      <v-card>
        <v-card-title>
          Registrar proyecto
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <RegistrarProyecto
            ref="registrarProyecto"
            :id-obra="estaObra.id"
            v-on:cerrar="cerrarRegistrarProyecto">
          </RegistrarProyecto>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarRegistrarProyecto"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.registrarProyecto.guardar()"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OBRAS from '@/graphql/querys/administracion/planeacion/obras.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevaObra from '@/components/administracion/obras/Nuevo.vue';
import EditarObra from '@/components/administracion/obras/Editar.vue';
import EliminarObra from '@/components/administracion/obras/Eliminar.vue';
import ExportarObrasExcel from '@/components/exportar/exceles/ExcelObras.vue';
import RegistrarProyecto from '@/components/administracion/control-proyectos/NuevoProyecto.vue';
import eventBus from '@/helpers/eventBus';
import CustomButton from '@/components/buttons/Button.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'PlaneacionDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaObra,
    EditarObra,
    EliminarObra,
    ExportarObrasExcel,
    RegistrarProyecto,
    CustomButton,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarProyecto: false,
      mostrarVentanaRegistrarNuevaObra: false,
      mostrarVentanaEditarObra: false,
      mostrarVentanaEliminarObra: false,
      mostrarExportarObras: false,
      estaObra: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        programas: [],
      },
    };
  },
  apollo: {
    obras: {
      query: OBRAS,
    },
  },
  methods: {
    registrarNuevaObra() {
      this.mostrarVentanaRegistrarNuevaObra = true;
    },
    cerrarRegistrarNuevaObra() {
      this.mostrarVentanaRegistrarNuevaObra = false;
    },
    cerrarEditarObra() {
      this.mostrarVentanaEditarObra = false;
      this.estaObra = null;
    },
    cerrarRemoverObra() {
      this.mostrarVentanaEliminarObra = false;
      this.estaObra = null;
    },
    cerrarRegistrarProyecto() {
      this.$refs.registrarProyecto.cancelar();
      this.mostrarRegistrarProyecto = false;
      this.estaObra = null;
    },
  },
  computed: {
    getObras() {
      if (!this.obras) return [];
      return this.obras;
    },
    getListadoObras() {
      if (!this.obras) return [];
      return this.obras
        .slice()
        .sort((a, b) => (`${a.clave}`).localeCompare(b.clave))
        // Filtrar por Ejercicio
        .filter(({ ejercicio }) => {
          if (typeof this.filtros.ejercicio === 'string') {
            const split = this.filtros.ejercicio.split('-');
            const splitEjercicio = Number(split[0]);
            return ejercicio === splitEjercicio;
          }
          return ejercicio === this.filtros.ejercicio;
        })
        // Filtrar por Tipo
        .filter(({ idTipo }) => {
          const { tipos } = this.filtros;
          if (tipos.length <= 0) return true;
          return tipos.includes(idTipo);
        })
        // Filtrar por Programa
        .filter(({ idPrograma }) => {
          const { programas } = this.filtros;
          if (programas.length <= 0) return true;
          return programas.includes(idPrograma);
        })
        // Filtrar por Texto de Busqueda
        .filter((obra) => {
          if (!this.filtros.buscarTexto) return obra;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const clave = this.$normalizacionTexto(obra.clave);
          const meta = this.$normalizacionTexto(obra.meta);
          const municipio = this.$normalizacionTexto(obra.ubicacion.municipio.nombre);
          const programa = this.$normalizacionTexto(obra.programa.nombre);
          return (
            expt.test(clave)
            || expt.test(meta)
            || expt.test(municipio)
            || expt.test(programa)
            || expt.test(obra.clave)
            || expt.test(obra.meta)
            || expt.test(obra.ubicacion.municipio.nombre)
            || expt.test(obra.programa.nombre)
          );
        });
    },

  },
  mounted() {
    eventBus.$on('registrar-proyecto', (obra) => {
      this.estaObra = obra;
      this.mostrarRegistrarProyecto = true;
    });
    eventBus.$on('editar-obra', (obra) => {
      this.estaObra = obra;
      this.mostrarVentanaEditarObra = true;
    });
    eventBus.$on('eliminar-obra', (obra) => {
      this.estaObra = obra;
      this.mostrarVentanaEliminarObra = true;
    });
  },
};
</script>

<style lang="scss">

</style>
